import fetch, { Response, RequestInfo, RequestInit } from 'node-fetch';

export default class FetchService {
	/**
	 * Fetches JSON and handles error responses.
	 *
	 * @param requestInfo Request info.
	 * @param requestInit Request init.
	 * @returns Promise.
	 */
	public static async json(requestInfo: RequestInfo, requestInit?: RequestInit): Promise<unknown> {
		const response = await this.fetch(requestInfo, requestInit);

		if (typeof response.json === 'function') {
			try {
				return await response.json();
			} catch (error) {
				throw new Error(
					`fetchJson failed with response=${response}, error.message=${error.message}`
				);
			}
		}

		return response;
	}

	/**
	 * Fetches JSON and handles error responses.
	 *
	 * @param requestInfo Request info.
	 * @param requestInit Request init.
	 * @returns Promise.
	 */
	public static async fetch(
		requestInfo: RequestInfo,
		requestInit?: RequestInit
	): Promise<Response> {
		return typeof window !== 'undefined'
			? await window.fetch(requestInfo, requestInit)
			: await fetch(requestInfo, requestInit);
	}
}
